import { Box, Flex, Image, Stack } from '@chakra-ui/react'
import { LandingContainer } from 'components/common/LandingContainer'
import { Body1, Body3, H2, H5 } from 'components/typography'
import Link from 'next/link'
import { FC } from 'react'

import { specilistsData } from './specilistsData'

/** `withCredentials` (GEO home, PRD 7.6): the RQE next to the CRM and the name linked to the author page. */
const SpecialistsSection: FC<{ withCredentials?: boolean }> = ({ withCredentials = false }) => (
  <Box bg="phthalo" py={{ base: 12, lg: 32 }}>
    <LandingContainer>
      <Stack gap={{ base: '20px', lg: '36px' }} px={6} mb={{ base: '56px', lg: '76px' }}>
        <H2 color="magicmint">
          Os melhores <br /> especialistas
        </H2>
        <Body1 maxW="420px" color="magicmint">
          Na Omens você encontra os profissionais mais experientes e influentes nas áreas de vida sexual e tratamentos
          de pele.
        </Body1>
      </Stack>

      <Flex
        px={6}
        maxW={{ base: '400px', md: '1280px', lg: '1280px' }}
        direction={{ base: 'column', md: 'row', lg: 'row' }}
        gap={{ base: '32px', lg: '24px' }}
        mx="auto"
      >
        {specilistsData.map((specialist) => (
          <SpecialistCard key={specialist.registry} {...specialist} withCredentials={withCredentials} />
        ))}
      </Flex>
    </LandingContainer>
  </Box>
)

export default SpecialistsSection

interface SpecialistCardProps {
  name: string
  specialty: string
  imgSrc: string
  registry: string
  background: string[]
  publicationLink: string
  linkText: string
  rqe: string
  profilePath: string
  withCredentials: boolean
}

const SpecialistCard: FC<SpecialistCardProps> = ({
  name,
  specialty,
  imgSrc,
  linkText,
  registry,
  background,
  publicationLink,
  rqe,
  profilePath,
  withCredentials
}) => (
  <Stack gap={{ base: '20px', lg: '24px' }} flex="1">
    <Image
      loading="lazy"
      objectFit="cover"
      objectPosition="top"
      src={imgSrc}
      alt={name}
      h={{ base: '280px', lg: '364px' }}
      borderRadius={{ base: '24px', lg: '40px' }}
    />

    <Box h="2px" bg="magicmint" w="full" opacity="0.1" />

    <Flex gap="24px" direction={{ base: 'column', lg: 'row' }}>
      <Stack flex="2">
        <H5 color="magicmint">
          {withCredentials ? (
            <Link prefetch={false} href={profilePath}>
              {name}
            </Link>
          ) : (
            name
          )}
        </H5>

        <Box>
          <Body1 color="magicmint">{specialty}</Body1>
          <Body1 color="magicmint">{withCredentials ? `${registry} · ${rqe}` : registry}</Body1>
        </Box>
      </Stack>
      <Stack flex="3" spacing="4px">
        {background.map((line, index) => (
          <Body3 color="magicmint" key={index}>
            {line}
          </Body3>
        ))}

        <Link prefetch={false} href={publicationLink} target="_blank" passHref>
          <Body3 mt="16px" color="magicmint">
            {linkText} →
          </Body3>
        </Link>
      </Stack>
    </Flex>
  </Stack>
)
